<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div v-if="name" class="right-menu">
      <el-dropdown v-if="userTypeList.length > 1" class="right-menu-item">
        <div class="role">[{{ userTypeList.filter(item => item.current)[0].name }}]</div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) in userTypeList" :key="index" :disabled="userTypeList.filter(subItem => subItem.current)[0].userType === item.userType" :divided="index !== 0" @click.native="setUserType(item.userType)">切换至{{ item.name }}身份</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="right-menu-item">
        <div class="avatar-wrapper">
          <svg-icon icon-class="user" class-name="user" />
          <span>{{ name }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/account-infor/index">
            <el-dropdown-item>基本信息</el-dropdown-item>
          </router-link>
          <!-- <router-link to="/account-infor/account-security">
              <el-dropdown-item>账号安全</el-dropdown-item>
          </router-link> -->
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull';
// import SizeSelect from '@/components/SizeSelect'
// import Search from '@/components/HeaderSearch'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    // ErrorLog,
    // Screenfull,
    // SizeSelect,
    // Search
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'userTypeList',
      'avatar',
      'device',
    ]),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    setUserType(userType) {
      this.$store.dispatch('user/checkRoleAction', {
        id: userType,
      }).then(() => {
        if (userType === 1) { // 管理员
          this.$router.push({ name: 'Console' });
        }
        if (userType === 2) { // 老师
          this.$router.push({ name: 'teacherCenterTable' });
        }
        // setTimeout(() => {
        //   location.reload();
        // }, 0);
      });
    },
    async logout() {
      await this.$store.dispatch('user/logout');
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
  },
};
</script>

<style lang='scss' scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    flex: 1
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    display: flex;
    align-items: center;

    .right-menu-item {
      margin: 0 0 0 20px;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #5a5e66;
      line-height: 1.2em;
      .role {
        color: #1890ff;
        cursor: pointer;
      }

      .avatar-wrapper {
        cursor: pointer;
        .user {
          color: #666;
          font-size: 14px;
          margin: 0 3px 0 0;
        }
        .el-icon-caret-bottom {
          margin: 0 15px 0 5px;
        }
      }
    }
  }
}
</style>
